import { styled } from "@mui/material/styles";
import {
  Box,
  Drawer,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";


export const StyledDrawer = styled(Drawer)(({ theme }) => ({
  "& .MuiDrawer-paper": {
    backgroundColor: theme.palette.background.primary,
    color: "#fff",
    borderRight: "1px solid #e2e8f0",
    boxShadow: "4px 0 20px rgba(0, 0, 0, 0.05)",
    overflowX: "hidden",
    transform: "initial !important",
    visibility: "visible !important",
    transition: "transform 0.3s ease-in-out, visibility 0.3s ease-in-out",
    [theme.breakpoints.down("md")]: {
      visibility: "unset !important",
    },
  },
}));

export const UserSection = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2.5, 2),
  boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
  backgroundColor: theme.palette.background.primary,
  color: "white",
  minHeight: { xs: "70px", md: "80px" },
  "& .siderBarTop": {
    display: "flex",
    alignItems: "center",
    gap: 2,
    position: "relative",
    "& .avatarIcon": {
      bgcolor: "white",
      color: "black",
      width: 40,
      height: 40,
      fontSize: "14px",
      fontWeight: 600,
    },
    "& .userName": {
      backgroundColor: theme.palette.background.white,
      color: "#03A9F4",
      width: 40,
      height: 40,
      borderRadius: "12px",
      fontSize: "16px",
      fontWeight: "bold",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    "& .MuiTypography-h4": {
      fontSize: "20px",
      fontWeight: "bold",
      color: "white",
      marginBottom: "9px",
    },
    "& .MuiTypography-h5": {
      backgroundColor: theme.palette.background.white,
      color: "#0F1729",
      borderRadius: "35px",
      fontSize: "16px",
      fontWeight: "bold",
      display: "inline",
      padding: "5px 11px",
    },
  },
}));

export const StyledListItemButton = styled(ListItemButton, {
  shouldForwardProp: (prop) => prop !== "open" && prop !== "isItemActive",
})(({ open, isItemActive }) => ({
  justifyContent: open ? "initial" : "center",
  padding: open ? "6px 20px" : "5px",
  marginBottom: open ? "3px" : "20px",
  marginInline: 8,
  borderRadius: 16,

  backgroundColor: isItemActive ? "#0277BD" : "transparent",
  color: isItemActive ? "#2563eb" : "#fff",
  "&:hover": {
    backgroundColor: "#0277BD",
    color: isItemActive ? "#2563eb" : "#e0f2fe",
  },
}));

export const StyledListItemIcon = styled(ListItemIcon, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ open }) => ({
  marginRight: open ? 1 : "auto",
  justifyContent: "center",
  color: "#ffffff",
  fontSize: "30px",
}));

export const StyledListItemText = styled(ListItemText, {
  shouldForwardProp: (prop) => prop !== "open" && prop !== "isItemActive",
})(({ open, isItemActive }) => ({
  display: open ? "flex" : "none",
  "& .MuiTypography-root": {
    color: "#ffffff",
    fontSize: "16px",
    fontWeight: isItemActive ? 400 : 400,
  },
}));
